import { Provider } from 'mobx-react'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
// import * as serviceWorker from './serviceWorker';
import store, { StoreContext } from './store'
import { deleteConsole } from './utils/helper'
import { initSentry } from './utils/sentry'
import sa from './utils/statis'

//sentry
initSentry()

//简单去console打印
deleteConsole()

// sa 统计
sa.Init()

ReactDOM.render(
  <Provider {...store}>
    <StoreContext.Provider value={store}>
      <App />
    </StoreContext.Provider>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
